import { render, staticRenderFns } from "./LoadingZone.vue?vue&type=template&id=e2fd9842&scoped=true&"
import script from "./LoadingZone.vue?vue&type=script&lang=js&"
export * from "./LoadingZone.vue?vue&type=script&lang=js&"
import style0 from "./LoadingZone.vue?vue&type=style&index=0&id=e2fd9842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fd9842",
  null
  
)

export default component.exports